var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 328.461,
    height: 485.998,
    viewBox: "0 0 328.461 485.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    transform: "translate(-957.114 -726.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M1719.644,1511.625h307.8l15.152-160.185-70.761-172.928-165.853-17.843-91.841,171.594c1.785,59.873,3.727,119.622,5.508,179.362",
    transform: "translate(-757.023 -299.459)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M1921.769,1346.823l77.37,1.954,25.807-61.508,18.187,62.616,61.7,1.558-70.761-172.931-165.854-17.842Z",
    transform: "translate(-819.262 -299.472)",
    fill: "#345f5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M1995.19,1112.108l1.866,73.33-31.376-18.392.157-55.085Z",
    transform: "translate(-858.635 -279.79)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M1837.545,1603.9l2.858-71.982c-.069-1.471-64.416-3.522-63.935.461,1.481,12.207,2.685,44.1,3.277,71.327,14.18-1.211,47.317-.642,57.8.193m-54.74-39.806c-.436-10.236-.968-19.012-1.551-23.835-.167-1.39,9.837-1.826,20.9-1.789l-.36,25.194Zm25.481-25.558c11.553.209,22.434.838,22.461,1.365l-.923,23.124-21.888.5Zm21.3,30.525-1.056,26.563c-4.017-.315-12.337-.588-21.044-.667l.359-25.406Zm-28.24,25.879c-6.812.017-13.291.176-17.563.536-.177-8.274-.426-17.109-.739-25.359l18.659-.427Z",
    transform: "translate(-782.199 -448.69)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M1790.026,992.328c5.793,21.792,27.665,22.775,43.857,14.662.893-.443,1.77-.887,2.65-1.3,1.552,7.544,6.948,15.811,15.3,20.793,10.546,6.271,23.315,4.481,28.71-2.427,7.651,5.162,16.472,9.15,23.616,8.31,10.9-1.279,17.205-8.327,17.884-18.962.641-10.019-4.65-19.811-11.886-27.794a13.889,13.889,0,0,0,.989-1.4c3.213-5.19,2.641-11.074-1.961-16.223-4.543-5.081-14.467-6.709-21.16-6.559a16.046,16.046,0,0,0,.33-5.285c-1.3-13.191-14.538-11.436-18.2-2.189-.655-1.159-1.217-2.392-1.79-3.658-4.78-10.512-15.193-19.2-25.09-11.579a15.02,15.02,0,0,0-2.636,2.632,40.968,40.968,0,0,0-11.552-5.645c-9.857-3.023-16.239-1.455-19.533,2.349-3.854,4.359-3.824,11.741-.642,18.883-13.764,6.218-23.234,19.083-18.893,35.394",
    transform: "translate(-787.248 -207.945)",
    fill: "#e2e7e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M2114.635,1671.769q4.538-57.333,9.056-114.663l-44.031.07c-1.123,38.264-2.161,76.386-3.28,114.594Z",
    transform: "translate(-903.352 -459.608)",
    fill: "#f8f9f9",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.9d68cb2bc9921d11e333d20487ae7bd8.svg";
export { ForwardRef as ReactComponent };